export default {
    auth: [
        {
            key: 'ONLINE_SERVICES',
            value: 'online.services',
            id: 'online-services-menu',
            description: 'homepage.online.services.description',
            submenu: [
                {
                    key: 'TRADEMARKS',
                    value: 'trademarks',
                    path: '/online-services/trademark',
                    id: 'trademarks-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_TRADEMARKS'),
                },
                {
                    key: 'DESIGNS',
                    value: 'designs',
                    path: '/online-services/design',
                    id: 'designs-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_DESIGNS'),
                },
                {
                    key: 'PATENTS',
                    value: 'patents',
                    path: '/online-services/patents',
                    id: 'patents-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_PATENTS'),
                },
            ],
        },
        {
            key: 'FAVOURITE_SERVICES',
            value: 'homepage.favourites.services',
            id: 'favourites-services-menu',
            description: 'homepage.favourites.services.description',
            submenu: [
                {
                    key: 'TRADEMARKS',
                    value: 'trademarks',
                    path: '/online-services/trademark/favourites',
                    id: 'favourites-trademarks-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_TRADEMARKS'),
                },
                {
                    key: 'DESIGNS',
                    value: 'designs',
                    path: '/online-services/design/favourites',
                    id: 'favourites-designs-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_DESIGNS'),
                },
                {
                    key: 'PATENTS',
                    value: 'patents',
                    path: '/online-services/patents/favourites',
                    id: 'favourites-patents-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_PATENTS'),
                },
            ],
        },
        {
            key: 'MY_APPLICATIONS',
            value: 'my.applications.title',
            id: 'my-applications-menu',
            description: 'homepage.my.applications.description',
            submenu: [
                {
                    key: 'TRADEMARKS',
                    value: 'trademarks',
                    path: '/my-applications/trademark',
                    id: 'trademarks-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_TRADEMARKS'),
                },
                {
                    key: 'DESIGNS',
                    value: 'designs',
                    path: '/my-applications/design',
                    id: 'designs-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_DESIGNS'),
                },
                {
                    key: 'PATENTS',
                    value: 'patents',
                    path: '/my-applications/patents',
                    id: 'patents-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_PATENTS'),
                },
            ],
        },
        // {
        //     key: 'DRAFT_APPLICATIONS',
        //     value: 'my.draft.applications.title',
        //     id: 'draft-applications-menu',
        //     description: 'homepage.my.drafts.description',
        //     submenu: [
        //         {
        //             key: 'TRADEMARKS',
        //             value: 'trademarks',
        //             path: '/my-drafts/trademark',
        //             id: 'trademarks-menu',
        //             cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_TRADEMARKS'),
        //         },
        //         {
        //             key: 'DESIGNS',
        //             value: 'designs',
        //             path: '/my-drafts/design',
        //             id: 'designs-menu',
        //             cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_DESIGNS'),
        //         },
        //         {
        //             key: 'PATENTS',
        //             value: 'patents',
        //             path: '/my-drafts/patents',
        //             id: 'patents-menu',
        //             cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_PATENTS'),
        //         },
        //     ],
        // },
        {
            key: 'PROFESSIONAL_SERVICES',
            value: 'professional.services.title',
            id: 'professional-services-menu',
            description: 'homepage.professional.services.description',
            cannotAccess: (_userType, authorities) =>
                !authorities || !authorities.some((r) => ['ROLE_UPDATE_OWNER_INFORMATION', 'ROLE_EDELIVERY', 'ROLE_PORTFOLIO'].includes(r)),
            submenu: [
                // {
                //     key: 'EDELIVERY',
                //     value: 'edelivery',
                //     path: 'edelivery.url',
                //     id: 'e-delivery-menu',
                //     cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_EDELIVERY'),
                //     externalPath: true,
                // },
                {
                    key: 'EDELIVERY',
                    value: 'communication.text',
                    path: 'edelivery.url',
                    id: 'e-delivery-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_EDELIVERY'),
                    externalPath: true,
                },
                {
                    key: 'PORTFOLIO',
                    value: 'portfolio.text.home',
                    path: 'portfolio.url',
                    id: 'portfolio-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_PORTFOLIO'),
                    externalPath: true,
                },
                {
                    key: 'UPDATE_OWNER_INFORMATION',
                    value: 'owners.information.text',
                    path: 'update.owners.information.url',
                    id: 'update-owner-information-menu',
                    cannotAccess: (_userType, authorities) => !authorities || !authorities.includes('ROLE_UPDATE_OWNER_INFORMATION'),
                    externalPath: true,
                },
            ],
        },
    ],
};
